import type { App } from 'vue'
import createKeyControlsService from '@services/key-controls-service'
import createPlayerService from '@services/player-service'
import createQueueService from '@services/queue-service'
import { keyControlsServiceKey } from '@composables/use-key-controls-service'
import { playerServiceKey } from '@composables/use-player-service'
import { queueServiceKey } from '@composables/use-queue-service'
import { useSettingsStore } from '@state/stores/settings'

export default {
    install(app: App) {
        const playerService = createPlayerService()
        const queueService = createQueueService({ playerService })
        const keyControlsService = createKeyControlsService(playerService, queueService)

        const settingsStore = useSettingsStore()

        playerService.setVolume(settingsStore.volume)
        playerService.on('settingsUpdate', settings => settingsStore.setSettings(settings))

        app.provide(playerServiceKey, playerService)
        app.provide(queueServiceKey, queueService)
        app.provide(keyControlsServiceKey, keyControlsService)
    },
}
